import { combineReducers } from '@ngrx/store';
import { PPTStoreState } from './ppt.model';
import { pptEntitiesReducer } from './entities';
import { pptStateReducer } from './ppt-state/ppt-state.reducer';

export const pptReducer = combineReducers<PPTStoreState>({
    state: pptStateReducer,
    entities: pptEntitiesReducer,
});
